import { render, staticRenderFns } from "./AuditoriaConfirmModal.vue?vue&type=template&id=45b10664"
import script from "./AuditoriaConfirmModal.vue?vue&type=script&lang=js"
export * from "./AuditoriaConfirmModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports